import React, { useEffect, useState } from "react";
import CustomerTable from "modules/customer_feedback/CustomerTable";
import CustomerFilter from "modules/customer_feedback/CustomerFilter";
import useStoreFeedback from "modules/customer_feedback/store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { use } from "echarts";
import moment from "moment";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";
import CardDiv from "modules/common/card-div/CardDiv";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { createSortHandler, removeSpaces } from "modules/utilities/utility";

function CustomerFeedback() {
  // const [page, newPage] = useState(1);
  const [customerFeedback, setCustomerFeedback] = useState([]);
  const {
    feedBackData,
    isLoading,
    feedbackLoading,
    error,
    fetchFeedbackData,
    fetchFeedbackFilterData,
  } = useStoreFeedback();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const [sortData, setSortedData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [page, newPage] = useState(1);
  const [inputChange, setInputChange] = useState("");

  useEffect(() => {
    newPage(Number(pageData));
  }, []);

  const initialStartDate = searchParams.get("sd");
  const initialEndDate = searchParams.get("ed");
  let numOfSubarrays = [];

  useEffect(() => {
    setSortedData(feedBackData);
  }, [feedBackData]);

  useEffect(() => {
    numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[pageData - 1]);
  }, [sortData, page, pageData]);

  useEffect(() => {
    if (startDate && endDate) {
      const encodeStartDate = encodeURIComponent(
        revenueRepStartDate(startDate)
      );
      const encodeEndDate = encodeURIComponent(revenueRepEndDate(endDate));

      fetchFeedbackFilterData(encodeStartDate, encodeEndDate);
      navigate(
        `/customerFeedback?pageNumber=${page}&sd=${encodeStartDate}&ed=${encodeEndDate}`
      );
    } else if (initialStartDate && initialEndDate) {
      fetchFeedbackFilterData(
        encodeURIComponent(initialStartDate),
        encodeURIComponent(initialEndDate)
      );
      navigate(
        `/customerFeedback?pageNumber=${page}&sd=${encodeURIComponent(
          initialStartDate
        )}&ed=${encodeURIComponent(initialEndDate)}`
      );
    }
  }, [startDate, endDate, initialStartDate, initialEndDate, page]);

  useEffect(() => {
    if (!inputChange) {
      setSortedData(feedBackData);
    }
    const inputData = removeSpaces(inputChange);
    const resultData = feedBackData.filter((item) => {
      const orderId = item?.order_display_id || "";
      const email = item?.user?.email || "";
      const phoneNumber = item?.user?.phone_number || "";
      const caseId = item?.case_id || "";
      return (
        orderId.includes(inputData) ||
        email.includes(inputData) ||
        phoneNumber.includes(inputData) ||
        caseId.includes(inputData)
      );
    });
    setSortedData(resultData);
  }, [inputChange]);

  const handleSortUpdatedDate = () =>
  createSortHandler(
    "updatedAt",
    count,
    setCount,
    setSortedData,
    setOpa,
    feedBackData || []
  );


  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div className="fs-1 mt-2">Customer Feedback</div>
          <div className="float-end">
            <CustomerFilter
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              sortData={sortData}
              setInputChange={setInputChange}
            />
          </div>
        </div>
      }
      component={
        <div className="mt-3">
          <CustomerTable
            data={filterData}
            isLoading={feedbackLoading}
            error={error}
            opa={opa}
            handleSortUpdatedDate={handleSortUpdatedDate}
          />
          <PaginationDiv
            paginationData={{ pageCount: pageCount || 1, page: page }}
            newPage={newPage}
            activePage={pageData}
          />
        </div>
      }
    />
  );
}

export default CustomerFeedback;
